"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _categoryProduct = require("@/api/category-product");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CategoryProductModal = _interopRequireDefault(require("./components/CategoryProductModal.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var CategoryProduct = /*#__PURE__*/function (_Vue) {
  function CategoryProduct() {
    var _this;
    (0, _classCallCheck2.default)(this, CategoryProduct);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CategoryProduct, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "listLoading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10,
      level: 1
    });
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "levelSelected", 1);
    (0, _defineProperty2.default)(_this, "parentIdSelected", null);
    (0, _defineProperty2.default)(_this, "queryLevel", {});
    (0, _defineProperty2.default)(_this, "categoryLevels", [{
      level: 1,
      categories: []
    }, {
      level: 2,
      categories: []
    }, {
      level: 3,
      categories: []
    }]);
    return _this;
  }
  (0, _inherits2.default)(CategoryProduct, _Vue);
  return (0, _createClass2.default)(CategoryProduct, [{
    key: "handleChangeCategoryLevel",
    value: function handleChangeCategoryLevel(categoryId, level) {
      this.levelSelected = !categoryId ? level : level + 1;
      this.parentIdSelected = categoryId;
      this.fetchCategoryByLevel(!categoryId ? level : level + 1, categoryId);
      this.query = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), {}, {
        page: 1,
        parentId: categoryId ? categoryId : this.queryLevel["parent".concat(level - 1, "Id")],
        level: categoryId ? level + 1 : level
      });
      this.fetchData();
      for (var i = level + 1; i <= 3; i++) {
        this.queryLevel["parent".concat(i, "Id")] = undefined;
      }
    }
  }, {
    key: "fetchCategoryByLevel",
    value: function () {
      var _fetchCategoryByLevel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(level, parentId) {
        var res, categoryLevel;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _categoryProduct.categoryProductApi.findAll({
                level: level,
                parentId: parentId
              });
            case 2:
              res = _context.sent;
              categoryLevel = this.categoryLevels.find(function (e) {
                return e.level == level;
              });
              categoryLevel.categories = res.data.data;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchCategoryByLevel(_x, _x2) {
        return _fetchCategoryByLevel.apply(this, arguments);
      }
      return fetchCategoryByLevel;
    }()
  }, {
    key: "handleDelete",
    value: function handleDelete(row) {
      var _this2 = this;
      this.$confirm("Bạn chắc chắn muốn xóa dữ liệu này?", "Cảnh báo", {
        confirmButtonText: "Xóa",
        cancelButtonText: "Không",
        type: "warning"
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$set(row, "loading", true);
              _categoryProduct.categoryProductApi.remove(row.id).then(function () {
                return _this2.fetchData();
              }).finally(function () {
                return _this2.$set(row, "loading", false);
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })));
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.categoryProductModal.handleUpdate(row);
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.$refs.categoryProductModal.handleCreate();
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
      this.fetchCategoryByLevel(1);
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this3 = this;
      this.listLoading = true;
      _categoryProduct.categoryProductApi.findAll(this.query).then(function (res) {
        _this3.data = res.data.data;
        _this3.total = res.data.total;
      }).finally(function () {
        return _this3.listLoading = false;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
CategoryProduct = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    CategoryProductModal: _CategoryProductModal.default,
    Pagination: _index.default
  }
})], CategoryProduct);
var _default = exports.default = CategoryProduct;